import { createAction } from 'redux-actions';

export const setTransactionNotesStatePerTransactionAction = createAction(
  'SET_TRANSACTION_NOTES_STATE_PER_TRANSACTION',
);
export const setTransactionNoteParamsAction = createAction('SET_TRANSACTION_NOTES_PARAMS');
export const resetTransactionNotesAction = createAction('RESET_TRANSACTION_NOTES');
